import React from 'react';

import * as Styled from './StyledPageBoxed';

export const PageBoxed = props => <Styled.PageBoxed {...props}>{props.children}</Styled.PageBoxed>;
export const Boxed = PageBoxed;
export default PageBoxed;
